/**
 * Get URL parameters
 * source: https://gomakethings.com/getting-all-query-string-values-from-a-url-with-vanilla-js/
 * @param  {String} url URL
 * @return {Object}     URL parameters
 */
export const getParams = (url) => {
  const params = {}
  const parser = document.createElement('a')
  parser.href = url
  const query = parser.search.substring(1)
  const vars = query.split('&')

  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split('=')
    params[pair[0]] = decodeURIComponent(pair[1])
  }

  return params
}


// WEBPACK FOOTER //
// /Users/sandersturing/Sites/SD/demo.test/frontend/source/utilities/url-parameters.js